import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/helpers.css'
import './styles/main.css'
import './styles/typo.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
